import { fetchCentreProviders } from '@/services/centreProvider'

export const setAllCentreProvidersController = async (params) => {
  try {
    const fetchAllCentreProviders = await fetchCentreProviders(params)
    return fetchAllCentreProviders
  } catch (error) {
    console.log(error.message)
    return error
  }
}
